/* eslint-disable max-len */
import React from "react";

const ShimmerLedgerTable = () => {
    const shimmerItems = Array.from({ length: 3 }, (_, index) => index);

    return (
        <div className="relative min-h-[512px]">
            <style>
                {`
                @keyframes shimmer {
                    0% {
                        background-position: -468px 0;
                    }
                    100% {
                        background-position: 468px 0;
                    }
                }

                .shimmer {
                    position: relative;
                    overflow: hidden;
                }

                .shimmer-item {
                    display: inline-block;
                    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
                    background-size: 800px 104px;
                    animation: shimmer 1.5s infinite linear;
                }
                `}
            </style>
            <h2 className="px-[10px] h-[36px] flex justify-between items-center text-lg font-semibold text-[#106EB4] bg-[#EEF7FE]">
                <span className="block w-1/4 h-6 shimmer-item"></span>
            </h2>
            <div className="pb-10 text-sm">
                {shimmerItems.map((_, index) => (
                    <div key={index} className="mb-4">
                        <div className="flex justify-between px-3 py-2.5 font-semibold shimmer">
                            <span className="block w-1/3 h-4 shimmer-item"></span>
                            <span className="block w-1/6 h-4 shimmer-item"></span>
                        </div>
                        <ul className="pl-8 pr-28 font-normal">
                            {shimmerItems.map((_, subIndex) => (
                                <li className="flex justify-between py-2.5 shimmer" key={subIndex}>
                                    <span className="block w-1/3 h-4 shimmer-item"></span>
                                    <span className="block w-1/6 h-4 shimmer-item"></span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="absolute bottom-0 text-base left-0 w-full px-2.5 h-9 font-semibold bg-[#EEF7FE] flex justify-between items-center shimmer">
                <span className="block w-1/6 h-6 shimmer-item"></span>
                <span className="block w-1/6 h-6 shimmer-item"></span>
            </div>
        </div>
    );
};

export default ShimmerLedgerTable;